module.exports = __webpack_public_path__ + "img/top@2x.c4e2ea7e.png";